import { Rate } from '../../Models/Rate/RateModels';
import {
  RatesGetResponse,
  RateGetResponse,
  RateCreateResponse,
  RateUpdateResponse,
  RateDeleteResponse,
  CreateRatePayload,
  UpdateRatePayload,
} from '../../Models/Rate/RateRequestResponseModels';
import HttpService from './HttpService';
import { pathRates, pathRateId } from '../../__settings__/septSoftwarePaths';

const http = new HttpService();

class RateService {
  static async getRates(): Promise<Rate[]> {
    const response = await http.get<RatesGetResponse>(pathRates);
    return response.data.rates;
  }

  static async getRateById(rateId: string): Promise<Rate> {
    const response = await http.get<RateGetResponse>(pathRateId(rateId));
    return response.data.rate;
  }

  static async createRate(payload: CreateRatePayload): Promise<Rate> {
    const response = await http.post<RateCreateResponse>(pathRates, payload);
    return response.data.rate;
  }

  static async updateRate(rateId: string, payload: UpdateRatePayload): Promise<Rate> {
    const response = await http.put<RateUpdateResponse>(pathRateId(rateId), payload);
    return response.data.rate;
  }

  static async deleteRate(rateId: string): Promise<string> {
    const response = await http.delete<RateDeleteResponse>(pathRateId(rateId));
    return response.data.message;
  }
}

export default RateService;
